/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import * as c from './constant';

export const getTaxCreditList = (
  payload = { is_paginated: 0, sort_by: 'desc' },
  callback
) =>
  req.list(
    c.GET_TAX_CREDIT,
    'api/v1/rpt/administrator/land/tax_credits',
    payload,
    callback
  );
export const getTaxCreditTransactionsList = (id, payload, callback) =>
  req.list(
    c.GET_TAX_CREDIT_TRANSACTIONS,
    `api/v1/rpt/administrator/land/tax_credits/${id}/logs`,
    payload,
    callback
  );

export const validateTaxCreditApplication = (payload, callback) =>
  req.item(
    c.VALIDATE_TAX_CREDIT,
    `api/v1/rpt/administrator/land/tax_credits/applications/validate`,
    callback,
    payload
  );

export const validateTransferReceiver = (id, payload, callback) =>
  req.item(
    c.VALIDATE_TAX_CREDIT,
    `api/v1/rpt/administrator/land/tax_credits/${id}/transfer/validate`,
    callback,
    payload
  );

export const transferTaxCredit = (id, payload, callback) =>
  req.create(
    c.TRANSFER_TAX_CREDIT,
    `api/v1/rpt/administrator/land/tax_credits/${id}/transfer`,
    payload,
    callback
  );

export const showTaxCreditByPin = (id, payload, callback) =>
  req.item(
    c.SHOW_TAX_CREDIT,
    `api/v1/rpt/administrator/land/tax_credits/pin/${id}`,
    callback,
    payload
  );

export const createTaxCredit = (payload, callback) =>
  req.create(
    c.CREATE_TAX_CREDIT,
    `api/v1/rpt/administrator/land/tax_credits`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateTaxCredit = (id, payload, callback) =>
  req.update(
    c.UPDATE_TAX_CREDIT,
    `api/v1/rpt/administrator/land/tax_credits/${id}/update`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeTaxCredit = (id, payload, callback) =>
  req.remove(
    c.REMOVE_TAX_CREDIT,
    `api/v1/rpt/administrator/land/tax_credits/${id}`,
    callback,
    payload
  );

export const showTaxCredit = (id, payload, callback) =>
  req.item(
    c.SHOW_TAX_CREDIT,
    `api/v1/rpt/administrator/land/tax_credits/${id}`,
    payload,
    callback
  );

export const getAdminModuleList = (payload, callback) =>
  req.list(
    c.GET_ADMIN_MODULE,
    'api/v1/administrators/admin_modules',
    payload,
    callback
  );
